module.exports = __webpack_public_path__ + "img/b04a7382d917a8f35060cba590b7d889.svg";